/* js/stepBase-type.js */


jQuery(document).ready(function ($) {

    var $selectBox = $('#meetingType')

    // Cache the target element
    var $selectValue = $('.js-bind-meeting-type');

    $('.js-bind-meeting-desc ').text($(this).find(':selected').data('desc'));

// Get initial value
    $selectValue.text($selectBox.val());

// Initialize Selectric and bind to 'change' event
    $selectBox.selectric({
        onChange: function () {
            $(this).closest('.formGroup').addClass('selectBox-active');
            $selectValue.text($(this).val());

            $('.js-bind-meeting-desc ').text($(this).find(':selected').data('desc'));



        }
    });


});